var base = require('settings/teams/update-team-name');

Vue.component('spark-update-team-name', {
    mixins: [base],

    /**
     * The component's data.
     */
    data() {
        return {
            form: new SparkForm({
                name: '',
                slug: ''
            }),
            // oldSlug: null
        };
    },

    watch: {
        /**
         * Watch the team name for changes.
         */
        'form.name': function (val, oldVal) {
            // if (this.form.slug == '' ||
            //     this.form.slug == oldVal.toLowerCase().replace(/[\s\W-]+/g, '-')
            // ) {
            //     this.form.slug = val.toLowerCase().replace(/[\s\W-]+/g, '-');
            // }

            // if (val !== oldVal) {
            //     this.form.slug = this.form.name.toLowerCase().replace(/[\s\W-]+/g, '-');
            // }

            // if (this.team.slug === this.team.name.toLowerCase().replace(/[\s\W-]+/g, '-')) {
            //     this.form.slug = val.toLowerCase().replace(/[\s\W-]+/g, '-');
            // }

            this.form.slug = val.toLowerCase().replace(/[\s\W-]+/g, '-');
        }
    },


    /**
     * Prepare the component.
     */
    mounted() {
        this.form.name = this.team.name;
        this.form.slug = this.team.slug;
    },

    methods: {
        /**
         * Update the team name.
         */
        async update() {
            // Spark.put(`/settings/${Spark.pluralTeamString}/${this.team.id}/name`, this.form)
            //     .then(() => {
            //         Bus.$emit('updateTeam');
            //         Bus.$emit('updateTeams');
            //     });



            if (this.form.slug !== this.team.slug) await Spark.put(`/settings/${this.team.id}/slug`, this.form)

            await Spark.put(`/settings/${Spark.pluralTeamString}/${this.team.id}/name`, this.form)

            Bus.$emit('updateTeam');
            Bus.$emit('updateTeams');
        }
    }
});
